<template>
  <div class="question">
    <div v-if="duration && !onePageTest" class="question__duration-block">
      <div>{{ $tr('responses.tabs.test.answer_time') }}</div>

      <div class="question__duration-block-time">
        <v-progress-linear
          :value="durationPercent"
          :color="progressDurationColor"
          height="26"
          class="question__duration-block-progress"
          rounded
        >
          <template #default>{{ duration }} / {{ timeLimit }}</template>
        </v-progress-linear>
      </div>

      <div v-if="hasNoAnswers">({{ $tr('responses.tabs.test.noAnswerFromCandidate') }})</div>
    </div>

    <div class="question__body" v-html="question.body"></div>

    <component :is="`${questionType}-question`" :question="question" />
  </div>
</template>

<script>
import ChoiceQuestion from './ChoiceQuestion';
import ValueQuestion from './TextQuestion';

export default {
  name: 'Question',

  components: {
    ValueQuestion,
    ChoiceQuestion,
    'multichoice-question': ChoiceQuestion
  },

  props: {
    question: {
      type: Object,
      default: () => {}
    },

    onePageTest: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    duration() {
      if (!this.question.duration) {
        return null;
      }

      let duration = this.question.duration;

      if (this.question.duration > this.question.time_limit) {
        duration = this.question.time_limit;
      }

      return this.$moment.duration(duration, 'seconds').format('mm:ss', { trim: false });
    },

    durationPercent() {
      const duration = this.question.duration;
      return Math.round((duration / this.question.time_limit) * 100);
    },

    progressDurationColor() {
      if (this.durationPercent < 90) {
        return '#99e38e';
      } else if (this.durationPercent >= 90 && this.durationPercent < 99) {
        return '#f0e4b3';
      } else {
        return '#ebc9bc';
      }
    },

    timeLimit() {
      if (!this.question.time_limit) {
        return null;
      }

      return this.$moment.duration(this.question.time_limit, 'seconds').format('mm:ss', { trim: false });
    },

    questionType() {
      if (this.question.type === 'value' || this.question.type === 'file') {
        return 'value';
      }

      return this.question.type;
    },

    hasNoAnswers() {
      if (this.question.answers.length === 1 && this.question.answers[0].body === null) {
        return true;
      }
      if (this.question.answers.every(x => !x.is_chosen)) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.question {
  font-weight: normal;
  max-width: inherit;

  &__body {
    margin: 42px 0 15px;
    // font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    color: #233346;

    ::v-deep img {
      max-width: 100%;
      width: auto;
    }
  }

  &__duration-block-progress {
    max-width: 200px;
  }

  &__duration-block {
    margin-top: 15px;
    margin-bottom: 15px;

    > div {
      margin-bottom: 10px;
    }
  }

  &__duration-block-time {
    display: flex;
  }
}

::v-deep .v-progress-linear__content {
  color: #777;
}
</style>
